import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { Role } from "@/core/components/auth/auth.types";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { salesAgentsQueryOptions } from "@/core/components/sales-agents/salesAgentQueryOptions";

const salesAgentsSearchSchema = z.object({
	page: z.number().catch(1),
	pageSize: z.number().catch(10),
	search: z.string().catch(""),
	sortBy: z
		.enum(["agentNumber", "type", "status", "createdAt"])
		.catch("agentNumber"),
	orderBy: z.enum(["asc", "desc"]).catch("asc"),
});

export const Route = createFileRoute("/_layout/dashboard/sales-agents/")({
	validateSearch: (search) => salesAgentsSearchSchema.parse(search),
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
		if (
			auth.user?.role === Role["Front-Desk"] ||
			auth.user?.role === Role["Blogger"]
		) {
			throw redirect({
				to: "/dashboard",
			});
		}
	},
	loader: ({ context: { queryClient, auth } }) =>
		queryClient.ensureQueryData(salesAgentsQueryOptions(auth.token as string)),
	errorComponent: ErrorComponent,
	pendingComponent: LoadingList,
});
